import { Injectable } from '@angular/core';
import { BaseNotifier } from './base-notifier';
import { Ref } from '../providers/ref';
import { LoadingState } from '../states/loading-state';

@Injectable({ providedIn: 'root' })
export class LoadingNotifier extends BaseNotifier<LoadingState> {
  private counter = 0;

  constructor(ref: Ref) {
    super(ref, { active: false });
  }

  start(): void {
    this.counter++;
    this.updateState(() => ({ active: true }));
  }

  stop(): void {
    this.counter = Math.max(0, this.counter - 1);
    if (this.counter === 0) {
      this.updateState(() => ({ active: false }));
    }
  }
}
